<template>
  <div>
    <div ref="slot">
      <slot></slot>
    </div>
    <div class="flex justify-between align-center">
      <p id="jobcat">{{name}}</p>
      <div v-if="isInitialized">
        <button type="button" class="entry-btn btn btn-sm btn-outline-info" @click="reset()">リセット</button>
        <button type="button" class="entry-btn btn btn-sm btn-info" data-toggle="modal" data-target="#jobCategoryModal">変更する</button>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">

  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  import modal_main from '../mixins/modal_main'
  const DATA_NAME = 'job_category'

  export default {
    mixins: [modal_main],
    computed: {
      ...mapGetters([
        [DATA_NAME],
        [DATA_NAME+'_id'],
      ]),
    },
    watch: {
      [DATA_NAME+'_id']: function () {
        if( typeof this[DATA_NAME+'_id'] === "undefined") return
        if( this[DATA_NAME+'_id'] === ''){
          this.name = ''
          this.slot_el.value = ''
          $(this.slot_el).trigger('change')
        }else{
          this.name = this[DATA_NAME][String(this[DATA_NAME+'_id'])].name
          this.slot_el.value = this[DATA_NAME+'_id']
          $(this.slot_el).trigger('change')
        }
      }
    },
    created(){
      this.clearData([DATA_NAME, DATA_NAME+'_id'])
    },
    mounted() {
      this.slot_el = this.$refs.slot.querySelector('input')
      this.requestFetchData({
        key: DATA_NAME,
        url: '/api/masters/job'
      })
    },
    data() {
      return {
        slot_el: null,
        name: null,
      }
    },
    methods: {
      initialized() {
        this.setValue({key: DATA_NAME+'_id', value: this.slot_el.value})
      },
      reset(){
        this.setValue({key: DATA_NAME+'_id', value: ''})
      },
    },
  }
</script>
